import { deserializeFileAsset } from "../../src/entities/FileAsset";
import { AssetCategory } from "../../src/entities/AssetCategory";
import { WebClient } from "./server/WebClient";

export interface SaveFileAssetRequest {
    parentId?: string; 
    name: string;
    category: AssetCategory;
    fileSize: number;
    uploadPath: string;
}

export interface UpdateFileAssetRequest {
    id: string; 
    parentId?: string; 
    name: string;
    isStarred: boolean;
    datePreached?: Date;
    locationPreached: string;
    scripture: string;
}

export const FileAssetService = {
    get: (id: string) => WebClient.Get(`/api/FileAssets/GetFileAsset/${id}`, deserializeFileAsset),
    generateUploadPath: (fileName:string) => WebClient.Post.Unvalidated<{url:string, filePath: string}>('api/FileAssets/GenerateFileUploadUrl/', { fileName: fileName }),
    uploadFile: (url:string, file:File, progress: (percentage: number) => void) => WebClient.Put.File.External(url, file, progress),
    save: (fileAssetToSave: SaveFileAssetRequest) => WebClient.Post.Validated(`/api/FileAssets/SaveFileAsset/`, fileAssetToSave, deserializeFileAsset),
    updateFileAsset: (fileAssetToSave: UpdateFileAssetRequest) => WebClient.Post.Validated(`/api/FileAssets/UpdateFileAsset/`, fileAssetToSave, deserializeFileAsset),
    remove: (id: string) => WebClient.Delete(`/api/FileAssets/DeleteFileAsset/${id}`),
    undeleteFileAsset: (id: string) => WebClient.Put.Validated(`api/FileAssets/UndeleteFileAsset/`, {id}, deserializeFileAsset),
    setName: (id: string, name: string) => WebClient.Put.Validated(`api/FileAssets/SetNameFileAsset`, {id, name}, deserializeFileAsset),
    setStarred: (id: string, isStarred: boolean) => WebClient.Put.Validated(`api/FileAssets/SetStarredFileAsset`, {id, isStarred}, deserializeFileAsset),
    move: (id: string, parentId: string | null) => WebClient.Put.Validated(`api/FileAssets/MoveFileAsset`, {id, parentId}, deserializeFileAsset),
    downloadFile: async(id:string, fileName:string) => {
        const response = await fetch(`/api/FileAssets/GetFileAssetContents/${id}`)
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.target = "_blank"
        link.href = url;
        link.download = `${fileName}`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}